/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Event_Updated_ToastInputs */

const en_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event tags updated successfully`)
};

const fr_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balises d'evenement mises a jour avec succes`)
};

const de_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis-Tags erfolgreich aktualisiert`)
};

const it_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag evento aggiornati correttamente`)
};

const ru_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метки событий успешно обновлены.`)
};

const es_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las etiquetas de eventos se actualizaron correctamente`)
};

const zh_cn2_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件标签已成功更新`)
};

const ja_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントタグが正常に更新されました`)
};

const hi_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टैग सफलतापूर्वक अपडेट हो गए`)
};

const pt_pt2_tags_event_updated_toast = /** @type {(inputs: Tags_Event_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas do evento atualizadas com sucesso`)
};

/**
* | output |
* | --- |
* | "Event tags updated successfully" |
*
* @param {Tags_Event_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_event_updated_toast = /** @type {((inputs?: Tags_Event_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Event_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_event_updated_toast(inputs)
	if (locale === "de") return de_tags_event_updated_toast(inputs)
	if (locale === "it") return it_tags_event_updated_toast(inputs)
	if (locale === "ru") return ru_tags_event_updated_toast(inputs)
	if (locale === "es") return es_tags_event_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_event_updated_toast(inputs)
	if (locale === "ja") return ja_tags_event_updated_toast(inputs)
	if (locale === "hi") return hi_tags_event_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_event_updated_toast(inputs)
	return en_tags_event_updated_toast(inputs)
});